<jft-chart-index-analytics *ngIf="user.settings.platts_subscriber; else noSubscriptionPlaceholder"></jft-chart-index-analytics>
<ng-template #noSubscriptionPlaceholder>
  <div class="card border-0 bg-light my-3">
    <div class="card-body text-center py-5">
      <i class="fas fa-chart-line fa-2x text-muted mb-3 opacity-50"></i>
      <h5 class="mb-2">Subscription required</h5>
      <p class="text-muted mb-3">This content is only visible for Argus Media or Platts subscribers.</p>
      <a class="btn btn-outline-primary btn-sm" routerLink="/account/platts">Add API credentials</a>
    </div>
  </div>
</ng-template>
